import { render, staticRenderFns } from "./GroupLeaveTypes.vue?vue&type=template&id=08cc7f61"
import script from "./GroupLeaveTypes.vue?vue&type=script&lang=js"
export * from "./GroupLeaveTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports